import React from "react";

import SettingsTabs from "superAdminViews/setting/SettingsTabs";
import CancelTripReason from "./CancelTripReason";
import DriverHowItWorks from "./DriverHowItWorks";
import DriverReadyComments from "./DriverReadyComments";
import Helps from "./Helps";
import Legals from "./Legals";
import ParcelVolume from "./ParcelVolume";
import ParcelWeight from "./ParcelWeight";
import PassengerReadyComments from "./PassengerReadyComments";
import ReadyMessages from "./ReadyMessages";
import ShopReadyComments from "./ShopReadyComments";

const TABS = [
  { path: "/driverReadyComment", label: "Driver comments", component: DriverReadyComments },
  { path: "/passengerReadyComment", label: "Passenger comments", component: PassengerReadyComments },
  { path: "/shopReadyComment", label: "Shop comments", component: ShopReadyComments },
  { path: "/cancelTripReason", label: "Cancellation reasons", component: CancelTripReason },
  { path: "/readyMessage", label: "Ready messages", component: ReadyMessages },
  { path: "/driverHowItWorks", label: "Driver how it works", component: DriverHowItWorks },
  { path: "/parcelVolume", label: "Parcel volume", component: ParcelVolume },
  { path: "/parcelWeight", label: "Parcel weight", component: ParcelWeight },
  { path: "/policies", label: "Policies", component: Legals },
  { path: "/help", label: "Help", component: Helps },
];

/**
 * Defaults - the wording the apps use when they speak for themselves.
 *
 * Everything here is text the customer, driver or shop reads inside an
 * app rather than in this panel: the canned comments, the cancellation
 * reasons, the policy pages and the help articles.
 */
const Defaults = () => (
  <SettingsTabs
    title="Default content"
    description="The canned text the customer, driver and shop apps show."
    base="/superAdmin/defaults"
    tabs={TABS}
  />
);

export default Defaults;
